__turbopack_context__.v({
  "emptyMessage": "Table-module__FFItaG__emptyMessage",
  "headerCell": "Table-module__FFItaG__headerCell",
  "headerContent": "Table-module__FFItaG__headerContent",
  "loader": "Table-module__FFItaG__loader",
  "loadingContainer": "Table-module__FFItaG__loadingContainer",
  "sortIcon": "Table-module__FFItaG__sortIcon",
  "sortIconInactive": "Table-module__FFItaG__sortIconInactive",
  "sortableHeader": "Table-module__FFItaG__sortableHeader",
  "spin": "Table-module__FFItaG__spin",
  "sticky": "Table-module__FFItaG__sticky",
  "stickyScrollbar": "Table-module__FFItaG__stickyScrollbar",
  "stickyScrollbarContent": "Table-module__FFItaG__stickyScrollbarContent",
  "table": "Table-module__FFItaG__table",
  "tableCell": "Table-module__FFItaG__tableCell",
  "tableFrame": "Table-module__FFItaG__tableFrame",
  "tableRow": "Table-module__FFItaG__tableRow",
  "tableScroll": "Table-module__FFItaG__tableScroll",
});
